export default __webpack_public_path__ + "static/media/black-widow.56c64c7a.jpg";